module.exports = __webpack_public_path__ + "img/alignment-wizard.a10ef471.svg";